import apiClient from './api';

// ====== Public API ======

export const getPhoneCatalog = (params = {}) => {
  const searchParams = new URLSearchParams();
  if (params.country) searchParams.append('country', params.country);
  if (params.city) searchParams.append('city', params.city);
  if (params.provider) searchParams.append('provider', params.provider);
  if (params.type) searchParams.append('type', params.type);
  if (params.search) searchParams.append('search', params.search);
  if (params.top_only) searchParams.append('top_only', 'true');
  if (params.page) searchParams.append('page', params.page);
  if (params.limit) searchParams.append('limit', params.limit);
  return apiClient.get(`/phone-catalog?${searchParams.toString()}`);
};

export const getPhoneCatalogEntry = (id) =>
  apiClient.get(`/phone-catalog/${id}`);

export const getPhoneCatalogCountries = () =>
  apiClient.get('/phone-catalog/countries');

export const getPhoneCatalogProviders = () =>
  apiClient.get('/phone-catalog/providers');

export const getPhoneCatalogCities = () =>
  apiClient.get('/phone-catalog/cities');

// ====== Admin API ======

export const getAdminPhoneCatalog = (params = {}) => {
  const searchParams = new URLSearchParams();
  if (params.country) searchParams.append('country', params.country);
  if (params.city) searchParams.append('city', params.city);
  if (params.provider) searchParams.append('provider', params.provider);
  if (params.type) searchParams.append('type', params.type);
  if (params.search) searchParams.append('search', params.search);
  if (params.top_only) searchParams.append('top_only', 'true');
  if (params.free_for_trial_only) searchParams.append('free_for_trial_only', 'true');
  if (params.page) searchParams.append('page', params.page);
  if (params.limit) searchParams.append('limit', params.limit);
  return apiClient.get(`/admin/phone-catalog?${searchParams.toString()}`);
};

export const createPhoneCatalogEntry = (entry) =>
  apiClient.post('/admin/phone-catalog', entry);

export const updatePhoneCatalogEntry = (id, entry) =>
  apiClient.put(`/admin/phone-catalog/${id}`, entry);

export const deletePhoneCatalogEntry = (id) =>
  apiClient.delete(`/admin/phone-catalog/${id}`);

export const togglePhoneCatalogTop = (id) =>
  apiClient.patch(`/admin/phone-catalog/${id}/top`);

export const togglePhoneCatalogFreeForTrial = (id) =>
  apiClient.patch(`/admin/phone-catalog/${id}/free-for-trial`);

export const importPhoneCatalog = (data, mapping) =>
  apiClient.post('/admin/phone-catalog/import', { data, mapping });

export const exportPhoneCatalog = () =>
  apiClient.get('/admin/phone-catalog/export', { responseType: 'blob' });

export const bulkDeletePhoneCatalog = (ids) =>
  apiClient.delete('/admin/phone-catalog/bulk', { data: { ids } });

export const bulkSetTopPhoneCatalog = (ids, isTopCountry) =>
  apiClient.patch('/admin/phone-catalog/bulk/top', { ids, is_top_country: isTopCountry });

export const bulkSetFreeForTrialPhoneCatalog = (ids, isFreeForTrial) =>
  apiClient.patch('/admin/phone-catalog/bulk/free-for-trial', { ids, is_free_for_trial: isFreeForTrial });

export const bulkSetCurrencyPhoneCatalog = (ids, currency) =>
  apiClient.patch('/admin/phone-catalog/bulk/currency', { ids, currency });

export const bulkSetFieldPhoneCatalog = (ids, field, value) =>
  apiClient.patch('/admin/phone-catalog/bulk/field', { ids, field, value });

// ====== DIDWW Integration ======

export const syncDIDWWRequirements = () =>
  apiClient.post('/admin/didww/sync');

export const getDIDWWStatus = () =>
  apiClient.get('/admin/didww/status');
